import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { clearCustomRequest, customRequestApis, } from "../../../store/customRequest/actions";
var REQUEST_KEY = "getLegacyQuoteDetails";
export var useGetLegacyQuoteDetail = function (_a) {
    var policyCode = _a.policyCode, enable = _a.enable, setSeeToast = _a.setSeeToast, t = _a.t;
    var dispatch = useDispatch();
    var loadingLegacyQuoteDetail = useSelector(function (state) { var _a, _b, _c; return (_c = (_b = (_a = state.CustomRequest) === null || _a === void 0 ? void 0 : _a.loadingCustomRequest) === null || _b === void 0 ? void 0 : _b[REQUEST_KEY]) !== null && _c !== void 0 ? _c : false; });
    var responseLegacyQuoteDetail = useSelector(function (state) { var _a, _b, _c; return (_c = (_b = (_a = state.CustomRequest) === null || _a === void 0 ? void 0 : _a.dataCustomRequest) === null || _b === void 0 ? void 0 : _b[REQUEST_KEY]) !== null && _c !== void 0 ? _c : null; });
    var errorLegacyQuoteDetail = useSelector(function (state) { var _a, _b, _c; return (_c = (_b = (_a = state.CustomRequest) === null || _a === void 0 ? void 0 : _a.errorCustomRequest) === null || _b === void 0 ? void 0 : _b[REQUEST_KEY]) !== null && _c !== void 0 ? _c : null; });
    useEffect(function () {
        if (!enable || !policyCode)
            return;
        dispatch(customRequestApis({
            requestKey: REQUEST_KEY,
            method: "GET",
            path: "/asg/Api/V1/Quote/legacy",
            queryParams: { isLegacy: true, legacyId: policyCode },
        }));
    }, [enable, policyCode, dispatch]);
    useEffect(function () {
        return function () {
            dispatch(clearCustomRequest(REQUEST_KEY));
        };
    }, []);
    return {
        responseLegacyQuoteDetail: responseLegacyQuoteDetail,
        loadingLegacyQuoteDetail: loadingLegacyQuoteDetail,
        errorLegacyQuoteDetail: errorLegacyQuoteDetail,
    };
};
